const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export type PriceType = 'monthly' | 'credit_pack';

interface CheckoutSessionResponse {
  sessionUrl: string;
  sessionId: string;
}

interface PortalSessionResponse {
  portalUrl: string;
}

/**
 * Create a Stripe Checkout Session and redirect user to Stripe's hosted checkout page
 */
export async function createCheckoutSession(
  priceType: PriceType,
  userId: string,
  userEmail: string
): Promise<void> {
  try {
    const response = await fetch(`${API_BASE_URL}/api/stripe/create-checkout-session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        priceType,
        userId,
        userEmail,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to create checkout session');
    }

    const data: CheckoutSessionResponse = await response.json();

    // Redirect to Stripe Checkout
    if (data.sessionUrl) {
      window.location.href = data.sessionUrl;
    } else {
      throw new Error('No session URL returned');
    }
  } catch (error) {
    console.error('Error creating checkout session:', error);
    throw error;
  }
}

/**
 * Open Stripe Customer Portal for managing subscriptions
 */
export async function openCustomerPortal(customerId: string): Promise<void> {
  try {
    const response = await fetch(`${API_BASE_URL}/api/stripe/create-portal-session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        customerId,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to create portal session');
    }

    const data: PortalSessionResponse = await response.json();

    // Redirect to Stripe Customer Portal
    if (data.portalUrl) {
      window.location.href = data.portalUrl;
    } else {
      throw new Error('No portal URL returned');
    }
  } catch (error) {
    console.error('Error opening customer portal:', error);
    throw error;
  }
}

